import APIService from '../api.service';

export const saveFCMToken = (payload) => {
  return APIService.put(`/v01/saveFCMToken`, {...payload})
}

export const fetchNotification = (params) => {
  return APIService.get(`/v01/notifications`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
}

export const markAsRead = (id) => {
  return APIService.put(`/v01/mark-as-read/${id}`);
}

export const markAllAsRead = (id) => {
  return APIService.put(`/v01/mark-all-as-read`);
}

export const fetchNotificationStats = () => {
  return APIService.get('/v01/notification-stats')
}

const NotificationService = {
  saveFCMToken,
  fetchNotification,
  markAsRead,
  fetchNotificationStats,
  markAllAsRead
};

export default NotificationService;
